























import Vue from 'vue';
import Component from 'vue-class-component';
import { QDate, QInput, QIcon, QPopupProxy } from 'quasar';
import { Watch } from 'vue-property-decorator';

@Component<QDateInput>({
  name: 'QDateInput',
  props: {
    value: {
      required: true,
      default: '',
    },
    inputProps: {
      type: Object,
    },
    isoFormat: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
      validator: (prop) => typeof prop === 'boolean' || prop === null,
    },
  },
  components: {
    QDate,
    QInput,
    QIcon,
    QPopupProxy,
  },
  watch: {
    value(newValue: string) {
      this.date = this.parseValue(newValue);
    },
  },
})
export default class QDateInput extends Vue {
  value!: string;

  readonly!: boolean;

  isoFormat!: boolean;

  $refs!: {
    datePicker: QDate;
    inputDate: QInput;
  };

  russianLocale = {
    days: 'Воскресенье_Понедельник_Вторник_Среда_Четверг_Пятница_Суббота'.split('_'),
    daysShort: 'Вс_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
    months: 'Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь'.split(
      '_'
    ),
    monthsShort: 'Янв_Февр_Март_Апр_Май_Июнь_Июль_Авг_Сент_Окт_Нояб_Дек'.split('_'),
    firstDayOfWeek: 1,
  };

  date: string = '';

  mounted(): void {
    this.date = this.parseValue(this.value);
  }

  showDatePicker(): void {
    if (!this.readonly) {
      // @ts-ignore
      this.$refs.datePicker.show();
    }
  }

  changeInput(val) {
    if (val && val.length === 10) {
      let [d, m, y] = val.split('.');
      m = (m % 13) - 1;
      y = y < 1900 ? 1900 : y > 2100 ? 2100 : y;
      this.date = this.toRussianDateFromString(y, m, d);
      if (this.date !== 'Invalid Date') {
        this.$refs.inputDate.blur();
        this.$emit('input', this.unparseValue(this.date));
      }
    } else {
      this.$emit('input', null);
    }
  }

  changeDate() {
    // @ts-ignore
    this.$refs.datePicker.hide();
    this.date = this.toRussianDate(this.date);
    this.$emit('input', this.unparseValue(this.date));
  }

  // eslint-disable-next-line class-methods-use-this
  toRussianDate(dateForChange): string {
    const russianDate = new Date(dateForChange).toLocaleString('ru', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });
    return russianDate;
  }

  // eslint-disable-next-line class-methods-use-this
  toRussianDateFromString(year, month, day): string {
    const russianDate = new Date(year, month, day).toLocaleString('ru', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });
    return russianDate;
  }

  private parseValue(value: string) {
    if (!value) return '';
    if (this.isoFormat) {
      return value.split('-').reverse().join('.');
    }

    return value;
  }

  private unparseValue(value: string) {
    if (this.isoFormat && value) {
      return value.split('.').reverse().join('-');
    }

    return value;
  }
}
